import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Trans } from "react-i18next";

const RemoveStudentModal = ({ target, onClose, onConfirm, isLoading, t }) => (
  <Modal show={!!target} onHide={onClose} centered size="sm">
    <Modal.Header closeButton>
      <Modal.Title style={{ fontSize: 16 }}>
        {t("remove")} {t("student")}
      </Modal.Title>
    </Modal.Header>
    <Modal.Body style={{ fontSize: 14 }}>
      {/* {target?.studentName} */}
      <Trans
        i18nKey="remove_reservation_confirm"
        values={{ studentName: target?.studentName }}
        components={{ strong: <strong /> }}
      />
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" size="sm" onClick={onClose}>
        {t("cancel")}
      </Button>
      <Button
        variant="danger"
        size="sm"
        disabled={isLoading}
        onClick={onConfirm}
      >
        {isLoading ? (
          <div className="spinner-border" role="status">
            <span className="sr-only p-0"></span>
          </div>
        ) : (
          t("remove")
        )}
      </Button>
    </Modal.Footer>
  </Modal>
);

export default RemoveStudentModal;
